import React from 'react';
import { withSnackbar } from '../../snackbar/SnackbarContext';
import SkidataChangeHistoryTable from './SkidataChangeHistoryTable';
import History from '@material-ui/icons/History';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import Typography from '@material-ui/core/Typography';

class OrderChangeHistorySection extends React.Component {
    render() {
        const { changeHistory } = this.props;

        return (
            <GridItem xs={12} sm={12} md={12} lg={12}>
                <Card>
                    <CardHeader color="rose" icon>
                        <CardIcon color="info">
                        <History />
                        </CardIcon>
                    </CardHeader>
                    <CardBody>
                        <Typography variant="headline" color="textSecondary">
                            Ereignisse
                        </Typography>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row-reverse',
                                marginTop: 10,
                            }}
                        >
                            <SkidataChangeHistoryTable
                                changeHistory={changeHistory}
                            />
                        </div>
                    </CardBody>
                </Card>
            </GridItem>
        );
    }
}

export default withSnackbar(OrderChangeHistorySection);


// WEBPACK FOOTER //
// ./src/views/skidata/components/OrderChangeHistorySection.jsx